/**
 * Mermaid via CDN — evita dependência npm; alinhado ao script de exportação.
 */
const MERMAID_SRC = 'https://cdn.jsdelivr.net/npm/mermaid@10.9.1/dist/mermaid.min.js';

export function loadMadriMermaid() {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('loadMadriMermaid: sem window'));
  }
  const w = window;
  if (w.mermaid) {
    return Promise.resolve(w.mermaid);
  }
  return new Promise((resolve, reject) => {
    const entry = { resolve, reject };
    if (!w.__madriMermaidWaiters) {
      w.__madriMermaidWaiters = [];
    }
    w.__madriMermaidWaiters.push(entry);
    if (w.__madriMermaidScriptLoading) {
      return;
    }
    w.__madriMermaidScriptLoading = true;
    const s = document.createElement('script');
    s.src = MERMAID_SRC;
    s.async = true;
    s.onload = () => {
      w.__madriMermaidScriptLoading = false;
      const waiters = w.__madriMermaidWaiters || [];
      w.__madriMermaidWaiters = null;
      const m = w.mermaid;
      waiters.forEach((wt) => {
        if (m) wt.resolve(m);
        else wt.reject(new Error('Mermaid indisponível após CDN'));
      });
    };
    s.onerror = () => {
      w.__madriMermaidScriptLoading = false;
      const waiters = w.__madriMermaidWaiters || [];
      w.__madriMermaidWaiters = null;
      const err = new Error('Falha ao carregar Mermaid (CDN)');
      waiters.forEach((wt) => wt.reject(err));
    };
    document.head.appendChild(s);
  });
}
